// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--6-1!../../../postcss-loader/lib/index.js??ref--6-2!./message-box.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("6e9325b3", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/message-box.css
// module id = 312
// module chunks = 1